var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 17H18V19H0V17ZM10 11.172L16.071 5.1L17.485 6.514L9 15L0.515 6.515L1.929 5.1L8 11.17V0H10V11.172Z","fill":"#727281"}));
}

Download.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = Download;

Download.default = Download;
